<template>
  <div class="vasco_page_">
    <a-carousel class="banner_wrap_" autoplay>
      <div><img :src="bannerImg" /></div>
    </a-carousel>
    <p class="tabs_wrap_">
      <a-button @click="tabIndex = 1" :class="{ active_: tabIndex == 1 }" class="item_ btn_default_">{{ $t('tabs.d') }}</a-button>
      <a-button @click="tabIndex = 2" :class="{ active_: tabIndex == 2 }" class="item_ btn_default_ mrg_l36_">{{ $t('header.e') }}</a-button>
      <a-button @click="tabIndex = 3" :class="{ active_: tabIndex == 3 }" class="item_ btn_default_ mrg_l36_">{{ $t('BOCI[6]') || '中银保险' }}</a-button>
    </p>
    <div class="content_wrap_">
      <ul
        :class="`${currentLang == 1 ? 'cn_height_' : 'en_height_'}`"
        class="p_list_"
      >

      <li v-if="/1|3/.test(tabIndex)" class="flex_item_">
        <div class="img_wrap_">
          <img src="../../assets/astp/7.jpeg" />
        </div>
        <div class="right_wrap_">
          <h1 class="h140_">
            {{
              $t("BOCI[8]") || "中银-申根保障计划（含新冠医疗）(互联网)"
            }}
          </h1>
          <div class="clearfix_ pre_wrap_">
            <p class="pre_wrap_">
              {{
                $t("BOCI[1]") ||
                `
一险在手，全面无忧
保障包含：
新冠保障
公共交通工具意外伤害
医疗费用保险金 （含门诊和住院）
亲属慰问探望保险
签证拒签
随时随地，安联关爱：
提供境外住院医疗直付服务
24小时救援热线
推荐医疗机构
`
                }}
              </p>
            </div>
            <div class="clearfix_ b_">
              <div v-if="currentLang == 1" class="price_wrap_"><span class="num_">97.00</span> 元起</div>
              <div v-else class="price_wrap_">start from RMB<span class="num_">97.00</span></div>
              <router-link
                :to="{
                  name: 'astpProductDetail',
                  query: { productCode: 'BOCI19', p: 'BOCI19', u:'39726' },
                }"
              >
                <a-button class="btn_" type="primary">
                  {{ $t("buttons.a") }}
                </a-button>
              </router-link>
            </div>
          </div>
        </li>
        <li v-if="/1|2/.test(tabIndex)" class="flex_item_">
          <div class="img_wrap_">
            <img src="../../assets/astp/4.png" />
          </div>
          <div class="right_wrap_">
            <h1 class="h140_">{{ $t('header.d') }}</h1>
            <div class="clearfix_ pre_wrap_">{{ $t('productInfo.a0') }} {{ $t('productInfo.a1') }} {{ $t('productInfo.b0') }} {{ $t('productInfo.b1') }} {{ $t('productInfo.c0') }} {{ $t('productInfo.c1') }} {{ $t('productInfo.d0') }} {{ $t('productInfo.d1') }} {{ $t('productInfo.e0') }} {{ $t('productInfo.e1') }}</div>
            <!-- 不要看git记录，这傻逼代码不是我写的，这锅我不背 -->
            <div class="clearfix_ b_">
              <div v-if="currentLang == 1" class="price_wrap_"><span class="num_">310.00</span> 元起</div>
              <div v-else class="price_wrap_">start from RMB<span class="num_">310.00</span></div>
              <router-link :to="{ name: 'astpProductDetail' }">
                <a-button class="btn_" type="primary">
                  {{ $t('buttons.a') }}
                </a-button>
              </router-link>
            </div>
          </div>
        </li>
        <!-- <li v-if="/1|3/.test(tabIndex)" class="flex_item_">
          <div class="img_wrap_">
            <img src="../../assets/astp/7.jpeg" />
          </div>
          <div class="right_wrap_">
            <h1 class="h140_">
              {{
                $t("BOCI[0]") || "中银-申根计划 保障（暂不含新冠COV-19医疗）"
              }}
            </h1>
            <div class="clearfix_">
              <p class="pre_wrap_">
                {{
                  $t("BOCI[1]") ||
                  `
一险在手，全面无忧
保障包含：
公共交通工具意外伤害
医疗费用保险金 （含门诊和住院）
亲属慰问探望保险
签证拒签
随时随地，安联关爱：
提供境外住院医疗直付服务
24小时救援热线
推荐医疗机构
`
                }}
              </p>
            </div>
            <div class="clearfix_ b_">
              <div v-if="currentLang == 1" class="price_wrap_">
                <span class="num_">56.00</span> 元起
              </div>
              <div v-else class="price_wrap_">
                start from RMB<span class="num_">56.00</span>
              </div>
              <router-link
                :to="{
                  name: 'astpProductDetail',
                  query: { productCode: 'BOCI18', p: 'ZY' },
                }"
              >
                <a-button class="btn_" type="primary">
                  {{ $t("buttons.a") }}
                </a-button>
              </router-link>
            </div>
          </div>
        </li> -->
      </ul>
      <div class="right_wrap_ intro_wrap_">
        <div class="top_ item_wrap_">
          <h1>{{ $t('intro.h1') }}</h1>
          <p>
            {{ $t('intro.a') }}
          </p>
        </div>
        <div class="middle_ item_wrap_">
          <h1>{{ $t('intro.h2') }}</h1>
          <p>
            {{ $t('intro.b') }}
          </p>
          <ul class="list_">
            <li>
              <i class="index_">1</i>{{ $t('intro.c') }}
              <router-link :to="{ name: 'astpPolicyQuery' }">{{ $t('header.pa') }}</router-link>
            </li>
            <li><i class="index_">2</i>{{ $t('intro.d') }}</li>
            <li><i class="index_">3</i>{{ $t('intro.e') }}</li>
          </ul>
        </div>
        <div class="bottom_ item_wrap_">
          <p>
            {{ $t('banner.bt') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import policyMixin from './mixins/policy';
export default {
  data() {
    return {
      tabIndex: 1,
      bannerImg: this.$i18n.locale == 'zh-cn' ? require('../../assets/astp/5-cn.png') : require('../../assets/astp/5.jpg'),
    };
  },
  mixins: [policyMixin],
  mounted() {
    sessionStorage.setItem('pathname', location.pathname);
    sessionStorage.setItem('creator', this.$route.query.c || '');
  },
};
</script>

<style lang="scss" scoped>
/* 移动端  */
@media all and (max-width: 750px) {
  .flex_item_ {
    display: flex;
    justify-content: space-between;
  }
  h1 {
    font-size: 5.3333vw;
  }
  .mrg_l36_ {
    /* margin-left: 36px; */
  }
  .mrg_b70_ {
    margin-bottom: 18.6667vw;
  }
  .w300_ {
    width: 80vw;
    margin-left: 5.3333vw;
  }
  .banner_wrap_ {
    margin-top: 5.8667vw;
    h3 {
      height: 80vw;
      background: #fff;
    }
    img {
      width: 100%;
      height: auto;
    }
  }
  .tabs_wrap_ {
    margin: 5.8667vw 0;
    font-size: 3.4667vw;
    display: flex;
    justify-content: space-around;
    .active_ {
      background: #ff3e18;
      color: #fff;
    }
  }
  .content_wrap_ {
    .right_wrap_ {
      font-size: 3.2vw;

      p {
        margin: 0;
      }
      .item_wrap_ {
        padding: 5.3333vw;
        background: #fff;
        margin-bottom: 5.3333vw;
        box-shadow: 0vw 3.7333vw 4.8vw 0.8vw rgba(229, 243, 234, 0.35);
        border-radius: 1px;
      }
      .top_ {
        font-size: 3.2vw;
        p {
          margin-top: 5.6vw;
        }
      }
      .middle_ {
        p {
          margin: 5.3333vw 0 11.4667vw;
        }
        .list_ {
          padding-left: 4.8vw;
          border-left: 1px solid #ff3e18;
          li {
            margin-bottom: 5.3333vw;
            position: relative;
            .index_ {
              width: 4.8vw;
              height: 4.8vw;
              background: #ff3e18;
              color: #fff;
              position: absolute;
              left: -6.9333vw;
              top: 0px;
              text-align: center;
            }
            &:last-child {
              .index_ {
                height: 10.1333vw;
                border-bottom: 5.3333vw solid #fff;
              }
            }
          }
        }
      }
    }
  }
  .intro_wrap_ {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .p_list_ {
    display: flex;
    flex-direction: column;
    align-items: center;
    vertical-align: top;
    overflow: hidden;
    &.cn_height_ {
      li {
        .pre_wrap_ {
          margin: 5.3333vw 0;
        }
      }
    }
    li {
      width: 100%;
      padding: 5.3333vw;
      box-sizing: border-box;
      box-shadow: 0vw 1.8667vw 4.8vw 0.8vw rgba(229, 243, 234, 0.35);
      margin-bottom: 5.3333vw;
      background: #fff;
      display: flex;
      float: left;
      border-radius: 1px;
    }
    .img_wrap_ {
      width: 40vw;
      height: auto;
      overflow: hidden;
      img {
        width: 100%;
        height: auto;
      }
    }
    .right_wrap_ {
      min-width: 53.3333vw;
      margin-left: 5.3333vw;
      flex: 1;
      .b_ {
        .price_wrap_ {
          font-weight: bold;
          .num_ {
            font-size: 6.9333vw;
          }
          color: #ff3e18;
        }
      }
    }
  }
}

/* PC端 */
@media all and (min-width: 751px) {
  .h140_ {
  }
  h1 {
    font-size: 20px;
  }
  .mrg_l36_ {
    margin-left: 36px;
  }
  .mrg_b70_ {
    margin-bottom: 70px;
  }
  .w300_ {
    width: 300px;
    margin-left: 30px;
  }
  .banner_wrap_ {
    margin-top: 22px;
    min-height: 362px;
    h3 {
      height: 300px;
      background: #fff;
    }
    img {
      width: 100%;
      height: auto;
    }
  }
  .tabs_wrap_ {
    margin: 22px 0;
    font-size: 13px;
    .active_ {
      background: #ff3e18;
      color: #fff;
    }
  }
  .content_wrap_ {
    .right_wrap_ {
      font-size: 12px;

      p {
        margin: 0;
      }
      .item_wrap_ {
        padding: 30px;
        background: #fff;
        margin-bottom: 36px;
        box-shadow: 0px 7px 18px 3px rgba(229, 243, 234, 0.35);
        border-radius: 1px;
      }
      .top_ {
        font-size: 12px;
        p {
          margin-top: 21px;
        }
      }
      .middle_ {
        p {
          margin: 20px 0 43px;
        }
        .list_ {
          padding-left: 18px;
          border-left: 1px solid #ff3e18;
          li {
            margin-bottom: 26px;
            position: relative;
            .index_ {
              width: 18px;
              height: 18px;
              background: #ff3e18;
              color: #fff;
              position: absolute;
              left: -26px;
              top: 0px;
              text-align: center;
            }
            &:last-child {
              .index_ {
                height: 38px;
                border-bottom: 20px solid #fff;
              }
            }
          }
        }
      }
    }
  }
  .intro_wrap_ {
    .item_wrap_ {
      width: 280px;
      display: inline-block;
      vertical-align: top;
      margin-right: 40px;
    }
  }
  .p_list_ {
    margin-bottom: 36px;
    margin-right: 36px;
    vertical-align: top;
    overflow: hidden;
    &.cn_height_ {
      li {
        height: 439px;
        .pre_wrap_ {
          white-space: pre-wrap;
        }
      }
    }
    &.en_height_ {
      li {
        height: 490px;
      }
    }
    li {
      position: relative;
      width: 480px;
      margin-right: 20px;
      padding: 22px 42px 22px 22px;
      box-shadow: 0px 7px 18px 3px rgba(229, 243, 234, 0.35);
      margin-bottom: 36px;
      background: #fff;
      display: flex;
      float: left;
      border-radius: 1px;
    }
    .img_wrap_ {
      width: 204px;
      height: auto;
      overflow: hidden;
      margin-right: 41px;
      img {
        width: 100%;
        height: auto;
      }
    }
    .right_wrap_ {
      min-width: 200px;
      flex: 1;
      .b_ {
        position: absolute;
        bottom: 20px;
        .price_wrap_ {
          font-weight: bold;
          .num_ {
            font-size: 26px;
          }
          color: #ff3e18;
        }
      }
    }
  }
}
</style>